module.exports = __webpack_public_path__ + "img/pie-chart-grey.5a6085ca.svg";